import initialStore from "../initialStore";

export default function settingsReducer(state = initialStore.settings, action) {
    switch (action.type) {
        
        default:
            return state;
    }
}
